<template>
<Ccombobox v-if="eSets.length"
           id="kangaroo.sets"
           :show-not-matched="true"
           :value="configSet"
           :values="eSets"
           data-qa="kangaroo.sets"
           @input="onChange"/>
</template>

<script>
import combobox from '@/vue/blocks/combobox';
import passedTestConfigSets from '~test-config-sets';
import customSets from '~custom-config-sets';

let testConfigSets = passedTestConfigSets.map(set => {
    return {
        ...set,
        title: 'test: ' + set.title,
    };
});

let data;
// eslint-disable-next-line no-prototype-builtins
if (!Object.prototype.hasOwnProperty.call(window, '__odrConfigSet')) {
    Object.defineProperty(window, '__odrConfigSet', {
        set (value) {
            data.configSet = value;
            window.localStorage.setItem('odrConfigSet', JSON.stringify(value));
        },
        get () {
            let set;
            try {
                set = JSON.parse(window.localStorage.getItem('odrConfigSet'));
            // eslint-disable-next-line no-empty
            } catch (ignore) {}

            return set;
        },
    });
}

data = {
    configSet: window.__odrConfigSet,
    customSets,
};

export default {
    components: {
        Ccombobox: combobox,
    },
    data () {
        return data;
    },
    computed: {
        eSets () {
            let defaultStep = customSets.find(set => set.id === null) ? [] : [{ title: 'default', id: null }];
            return defaultStep.concat(customSets.concat(testConfigSets).map(set => {
                return { id: set.title, ...set };
            }));
        },
    },
    methods: {
        onChange (value) {
            if (value !== undefined && window.__odrConfigSet !== value) {
                window.__odrConfigSet = value;
                this.$nextTick(() => {
                    window.location.reload();
                });
            }
        },
    },
};
</script>
